module.exports = __webpack_public_path__ + "img/img-form-soluciones.f5e64987.png";